import CrudTable from '../../components/CrudTable';

// QT#1: bảng theo dõi tương tác MXH (nhập tay — API Facebook/IG cần business token).
export default function SocialAdmin() {
  return (
    <CrudTable
      title="📣 Theo dõi tương tác mạng xã hội"
      table="social_mentions"
      columns={[
        { key: 'platform', label: 'Nền tảng', type: 'select', required: true, options: [
            { value: 'Facebook', label: 'Facebook' },
            { value: 'Instagram', label: 'Instagram' },
            { value: 'TikTok', label: 'TikTok' },
            { value: 'Google Review', label: 'Google Review' },
            { value: 'Khác', label: 'Khác' },
          ] },
        { key: 'author', label: 'Người đăng', type: 'text' },
        { key: 'content', label: 'Nội dung', type: 'textarea' },
        { key: 'url', label: 'Link', type: 'text', render: (r) => r.url ? <a href={r.url} target="_blank" rel="noreferrer">Mở ↗</a> : '—' },
        { key: 'sentiment', label: 'Cảm xúc', type: 'select', options: [
            { value: 'positive', label: '😊 Tích cực' },
            { value: 'neutral', label: '😐 Trung lập' },
            { value: 'negative', label: '😟 Tiêu cực' },
          ] },
        { key: 'status', label: 'Trạng thái', type: 'select', options: [
            { value: 'new', label: 'Mới' },
            { value: 'replied', label: 'Đã phản hồi' },
            { value: 'escalated', label: 'Cần xử lý gấp' },
            { value: 'closed', label: 'Đã đóng' },
          ] },
        { key: 'note', label: 'Ghi chú', type: 'textarea', inTable: false },
        { key: 'created_at', label: 'Lúc', type: 'datetime', inForm: false },
      ]}
    />
  );
}
